import axios, { AxiosInstance } from "axios";
import Config from "data/config";

const request: AxiosInstance = axios.create({
  baseURL: Config.api_email,
});

export default request;

